export default __webpack_public_path__ + "static/simi-3ae4adb5003cd25bdd85d317bc9c7ef7.png";